// Каталог строк (en). Собран из docs/i18n/strings.json.
// Правки вносить там и перезапускать tools/gen-i18n.mjs.

import type { Catalog } from './types.ts';

export const en: Catalog = {
  action: {
    buy: 'Buy on installments',
    create_offer_instead: 'List your own item',
    pay: 'Pay',
    publish_offer: 'Publish the listing',
  },
  admin: {
    add_collection: 'Add a collection',
    collection_address: 'Collection address',
    collections: 'Collections in the registry',
    contract: 'Contract',
    deal_code: 'Code for new deals',
    deal_code_changed: 'Last changed',
    deal_code_hint: 'Changes only for future deals — running ones keep their code, the only way not to change the rules mid-payment.',
    deal_code_never: 'Unchanged since deployment',
    deals_by_state: 'Deals',
    fee: 'Fee',
    fee_apply: 'Change the fee',
    fee_hint: 'Withheld from every payment. The 5% cap is hard-coded: a stolen key cannot raise it.',
    fee_only_new: 'The new fee applies only to deals created after the change. Running deals keep theirs.',
    handover: 'Handing over administration',
    handover_accept: 'Accept administration',
    handover_address: 'Successor\'s address',
    handover_cancel: 'Withdraw the offer',
    handover_current: 'Current admin',
    handover_hint: 'In two steps: first an offer, then acceptance from the other side. A one-message change would mean a typo in the address leaves the protocol without an admin forever — no fee, no registries, no withdrawals.',
    handover_next: 'Offered to',
    handover_none: 'No offer',
    handover_offer: 'Offer',
    handover_yours: 'Administration has been offered to you. Until you accept, the admin stays as it was.',
    item_address: 'Address of any item in this collection',
    item_hint: 'The item code comes from there: TON has no synchronous cross-contract read, so the master computes the item address itself.',
    layout_detected: 'Item layout',
    layout_unknown: 'Could not determine the item layout: the address matched none of the known ones. Such a collection must not be added — the contract would reject every deal on it anyway.',
    master: 'Master',
    no_code: 'No code at this address — the contract is not deployed',
    not_admin: 'This wallet is not the master admin',
    reading_code: 'Reading the code…',
    ref_key: 'Invitation key',
    ref_key_apply: 'Set the server key',
    ref_key_hint: 'The server signs invitations, the contract verifies them. The key must match in both places: if they diverge, the contract silently stops accepting invitations while the app keeps issuing them.',
    ref_key_in_contract: 'In the contract',
    ref_key_match: 'They match',
    ref_key_mismatch: 'They differ — invitations do not work',
    ref_key_none: 'Not set',
    ref_key_off: 'Turn invitations off',
    ref_key_on_server: 'On the server',
    registry_empty: 'Empty — not a single entry',
    registry_layout: 'layout',
    remove: 'Remove',
    requests_open: 'Open offers',
    retained: 'Held in contracts',
    stats: 'Service',
    subtitle: 'Visible only to the master admin wallet. The contract checks every command anyway.',
    title: 'Admin',
    volume: 'Paid in by buyers',
    withdraw: 'Fee withdrawal',
    withdraw_all: 'All',
    withdraw_amount: 'How much',
    withdraw_available: 'Available',
    withdraw_hint: 'The fee accumulates on the master itself. Only the admin can take it and only with this command — the master sends nothing on its own.',
    withdraw_send: 'Withdraw',
    withdraw_to: 'Send to',
  },
  board: {
    answer_now: 'Answer with terms',
    asked_this_item: 'They are asking for this exact item',
    buyers_have_already_named: 'Buyers have named their price. The biggest premium over floor comes first.',
    decline_request: 'Walk away',
    don_t_wait_buyer: 'Don\'t wait for a buyer — set your own terms and your listing lands on the market.',
    empty_state: 'EMPTY',
    every: 'every',
    floor_here: 'OUR FLOOR {{floor}}',
    no_requests_other_gifts: 'No offers on your other NFTs yet',
    over_floor: 'OVER FLOOR',
    payments: 'PAYMENTS',
    per_payment: 'per payment',
    per_payment_note: '{{n}} payments over {{days}}',
    request_expires: 'OFFER EXPIRES IN',
    requests_gifts: 'Offers on your NFTs',
    sort_expiry: 'BY EXPIRY',
    sort_payments: 'SHORTER SCHEDULE',
    sort_premium: 'BY AMOUNT',
    total: 'TOTAL',
    which_item: 'Which item you are giving',
    your_answer_hint: 'The buyer gets a notification. Until they agree, you are bound by nothing.',
    your_answer_sent: 'Your offer is sent',
    your_gift: 'YOUR NFT',
    your_gifts_count: 'YOURS {{n}}',
    yours_personally: 'TO YOU PERSONALLY',
  },
  builder: {
    all_on_sale: 'Your NFTs from these collections are listed for sale. While a lot is on a marketplace its contract owns it, not you — unlist it and it shows up here.',
    allowed_collections: 'What can be used as collateral',
    allowed_count: 'See the list · {{count}}',
    allowed_hint: 'The contract takes collateral only from these collections. It rejects anything else, and the gas for a refusal is still spent.',
    already_started: 'This item is already listed',
    already_started_hint: 'One step left: hand it to the contract — until then buyers do not see the listing. No need to list it twice: that deploys a second contract and wastes the gas.',
    arrives_when_deal_closes: 'comes in one sum at closing',
    buyer: 'to buyer',
    defer_price: 'Price of a deferral',
    defer_price_hint: '{{pct}}% of a scheduled payment — what the buyer pays on top to push the schedule by one period. It does not count towards the debt.',
    down_payment: 'DOWN PAYMENT',
    flow_locking: 'Handing over the NFT',
    flow_timeout: 'The contract is not visible yet',
    flow_timeout_hint: 'It may simply be late — your money has not gone anywhere. Look in “Deals” → “Seller”: once the contract shows up, the button to hand over the NFT is there.',
    flow_waiting: 'Waiting for the deal contract',
    flow_waiting_hint: 'The network is deploying the contract — usually half a minute. As soon as it appears, the button to hand over the NFT shows up here.',
    hidden_gifts: '{{count}} more NFTs — from collections not admitted here yet',
    if_buyer_defaults: 'IF THE BUYER DEFAULTS',
    later: 'Later, from “Deals”',
    live_preview: 'Live preview',
    lock_gift: 'Hand the NFT to the contract',
    no_gifts: 'No NFTs on this wallet',
    no_gifts_in_allowed: 'You own no NFTs from these collections. You can buy one on any marketplace — a deal is created from what you already own.',
    none: 'none',
    not_enough_gas: 'Your wallet holds {{have}}, and creating a listing needs {{need}} plus the network fee. It is not a payment to us: the money sits on the deal contract and comes back when the deal closes. Top up and come back.',
    not_owner_now: 'This NFT is not owned by your wallet right now — it looks listed for sale. Unlist it and come back: the deal is already created and waiting for the collateral.',
    on_sale: '{{count}} more NFTs are listed for sale — unlist them first to use as collateral',
    only_whitelisted: 'Only admitted collections are shown: the contract will not create a deal on the rest, and paying gas for a refusal would sting.',
    open_deal: 'Open the deal and hand over the NFT',
    payment_deferrals: 'Payment deferrals',
    payments_weekly: 'PAYMENTS · WEEKLY',
    per_payment: 'Right after the down payment — {{upfront}}, then {{each}} from each payment. The rest the contract holds: the buyer’s share comes out of it if they default.',
    pick_gift: 'What you are selling',
    price: 'Price, {{cur}}',
    price_with_floor: 'Price, {{cur}} · our floor {{floor}}',
    publish_hint: 'Check the terms: after publishing they cannot change — the contract keeps them fixed.',
    published: 'Listing created',
    published_hint: 'One step left: hand the NFT to the contract — until then buyers do not see the listing.',
    publishing: 'Publishing',
    refund_level: 'Refund level',
    registry_empty: 'No collection is admitted yet — nothing can be listed.',
    reload_gifts: 'Refresh the list',
    step: 'STEP',
    steps_collapse: 'Collapse',
    steps_show_all: 'Show the remaining {{count}} steps',
    straight_wallet_2: 'Reaches you as payments go',
    what_buyer_gets_back: 'What the buyer gets back on default — and what stays with you. Harsher terms come with a longer grace period.',
    you: 'YOU',
  },
  buyer: {
    always_visible: 'ALWAYS VISIBLE',
    due: 'DUE',
    i_lose: 'I LOSE',
    if_i_stop_now: 'If I stop now',
    overdue_grace_period_running: 'OVERDUE · GRACE PERIOD RUNNING',
    pay_ahead: 'Pay ahead',
    push_payment_week: 'Push the payment by a week',
    received_wallet: 'RECEIVED IN WALLET',
    safe_pay_until: 'Safe to pay until',
    schedule: 'Schedule',
  },
  confirm: {
    balance_after: 'GRAM · balance after: {{rest}}',
    balance_unknown: 'GRAM · balance unknown',
    cancel_deal: 'Cancel the deal?',
    cancel_deal_body: 'The NFT comes back to you and the listing leaves the market. While the down payment is unpaid this costs nothing.',
    charged_now: 'CHARGED NOW',
    claim_gift: 'Take the NFT back?',
    claim_gift_body: 'The deal closes for good. The buyer gets the refund its terms promise, the rest stays with you.',
    defer: 'Push the payment?',
    defer_body: 'The whole schedule shifts by one period. The deferral price does not count towards the debt — it is a separate fee.',
    handover: 'Offer the handover?',
    handover_accept: 'Accept administration?',
    handover_accept_body: 'Once accepted, the previous admin loses rights immediately and only the new one can hand them back.',
    handover_body: 'Rights pass only after the other side accepts. Until then nothing changes and the offer can be withdrawn.',
    if_quit: 'If you stop after the first payment, {{back}} of the {{paid}} paid comes back, and the NFT goes to the seller.',
    legal: 'By confirming the payment you accept the smart contract’s terms. Settlement happens on TON; the service holds no funds.',
    not_enough: 'Your wallet holds less than the down payment requires.',
    registry_add: 'Add to the registry?',
    registry_add_body: 'From now on the master accepts such collections into deals. Check the address: the code is taken from the contract you named.',
    registry_remove: 'Remove from the registry?',
    registry_remove_body: 'New deals on this collection become impossible. Running ones continue — the master does not reach them.',
    set_fee: 'Change the fee?',
    set_ref_key: 'Change the invitation key?',
    set_ref_key_body: 'Only new deals get the new key: existing ones keep theirs, otherwise the change would void every invitation already issued.',
    transfer_position: 'Hand over the position?',
    transfer_position_body: 'The right to every remaining payment moves to this address. It cannot be undone, and the contract holds no money for the position — settle up before you hand it over.',
    upfront_title: 'Confirm the down payment',
    withdraw: 'Withdraw the fee?',
    withdraw_body: 'The transfer leaves the master\'s wallet for the address you gave. If the address does not work, the transfer bounces back rather than burning.',
  },
  counter: {
    accept: 'Accept the terms',
    accepted_hint: 'The seller is putting the NFT into the contract. Once that happens the deal shows up in My deals — that is where the down payment goes.',
    accepted_title: 'Terms accepted',
    asked: 'YOU ASKED FOR',
    decline: 'Decline',
    deferrals: 'Deferrals',
    down: 'Down',
    down_payment_only: 'Down payment only',
    expires_in: 'You can answer for',
    grace: 'Grace period',
    item: 'Which item',
    my_offers: 'My offers',
    none: 'No answers yet',
    payments: 'Payments',
    refund: 'Refund',
    status_accepted: 'Accepted',
    status_declined: 'Declined',
    status_expired: 'The time to answer ran out',
    status_open: 'Waiting on you',
    they_offer: 'THEY OFFER',
    total: 'Total',
    withdraw: 'Withdraw the offer',
  },
  deal: {
    cancel_deal: 'Cancel and take the NFT back',
    deal_total: 'Deal total',
    down_payment: 'Down payment',
    service_fee: 'Service fee',
  },
  deals: {
    comes_at_closing: 'arrives when the deal closes',
    from_upfront: '{{upfront}} from the down payment + {{n}} × {{each}}',
    grace_note: 'This is the end of the grace period, not the payment date. After it the deal defaults.',
    in_escrow: 'IN ESCROW',
    left_payments: 'Payments left: {{n}}',
    none: 'No deals yet',
    paid_of: 'Paid {{paid}} of {{total}}',
    payment_n: 'Payment {{n}}',
    payment_of: 'PAYMENT {{n}} OF {{total}}',
    running_level: 'DEAL RUNNING · LEVEL {{pct}}%',
    schedule_ahead: 'ahead',
    schedule_overdue: 'overdue',
    schedule_paid: 'paid',
    waiting_in_contract: 'WAITING IN THE CONTRACT',
  },
  err: {
    api_disabled: 'The service is temporarily unavailable',
    auth_date_future: 'The launch time is in the future — check your clock',
    bad_address: 'This does not look like a wallet address',
    bad_body: 'The request was malformed — try again',
    bad_key: 'The wallet key is malformed',
    bad_payments_count: 'Payments must be between 1 and 52',
    bad_proof_payload: 'The signature expired, try again',
    bad_terms: 'The contract would reject these terms',
    bad_tier: 'Unknown refund level',
    bad_user: 'Telegram sent data we could not read',
    connect_wallet: 'Connect a wallet first',
    counter_not_found: 'Offer not found',
    counter_not_live: 'The offer is no longer live',
    deadline_too_far: 'A deal cannot run longer than 400 days',
    deal_not_found: 'Deal not found',
    defer_fee_too_high: 'Deferral costs more than a quarter of a payment',
    domain_not_allowed: 'The signature was made on a different domain',
    forbidden: 'Access denied',
    init_data_expired: 'The session is stale. Open the app again.',
    internal: 'The service could not handle the request. We see it — try again in a minute.',
    key_not_32_bytes: 'The wallet key has the wrong length',
    key_not_hex: 'The wallet key is malformed',
    key_not_owner: 'This key does not own the address given',
    network: 'The server is not responding',
    no_address: 'No wallet address was sent',
    no_auth_date: 'The Telegram data carries no launch time',
    no_collection: 'No collection chosen',
    no_init_data: 'Open the app from Telegram',
    no_signature: 'Telegram did not sign the app launch',
    no_such_method: 'The app called the wrong address — reload it',
    no_user: 'Telegram did not say who you are',
    no_user_id: 'Telegram did not pass your id',
    not_the_owner: 'This offer is addressed to the item’s owner — only they can answer it',
    not_your_counter: 'This is not your offer',
    not_your_request: 'This is not your offer',
    nothing_to_pay: 'Nothing to pay right now',
    other_item: 'This offer is for a different item',
    payload_mismatch: 'The signature covers the wrong string. Start the confirmation again.',
    payment_below_min: 'A scheduled payment is below {{min}} — the contract rejects such a transfer. Raise the price or use fewer payments.',
    period_too_short: 'The period is shorter than three days',
    price_zero: 'The price must be above zero',
    proof_expired: 'The wallet signature expired, sign again',
    proof_future: 'The wallet signature is from the future — check your clock',
    proof_required: 'A wallet signature is required',
    referrals_off: 'Invites are switched off right now',
    request_not_found: 'Offer not found',
    request_not_live: 'The offer is no longer live',
    rounds_exhausted: 'Haggling is over: three rounds are done',
    schedule_past_deadline: 'The schedule with deferrals does not fit the deal term',
    self_account: 'This is your own invite',
    self_wallet: 'You cannot invite yourself',
    seller_is_buyer: 'You cannot answer your own offer',
    signature_mismatch: 'The signature does not check out',
    signature_not_base64: 'The wallet signature is malformed',
    signature_not_hex: 'The Telegram signature is malformed',
    too_many_deferrals: 'No more than three deferrals',
    unknown: 'Something went wrong',
    unknown_code: 'No such invite code',
    upfront_below_min: 'The down payment is below {{min}} — the contract rejects such a transfer. Raise the price or the down-payment share.',
    upfront_out_of_range: 'The down payment must be 10–50% of the price',
    upfront_too_large: 'The down payment is over half the price',
    upfront_too_small: 'The down payment is under 10% of the price',
    wallet_disconnected: 'The wallet got disconnected. Connect it again — the terms are kept.',
    wallet_not_confirmed: 'The wallet is not confirmed. Confirm it in your profile — this is a one-time step.',
    wallet_sdk: 'The wallet did not confirm the transfer and did not say why. Nothing was charged. If you closed the wallet window, that is what happened; if not, open the wallet, come back and try again. If it repeats, message support — we have a record of this failure.',
    wallet_unreachable: 'The wallet never got the request: TON Connect could not reach it. Nothing was charged — check your connection and try again.',
    wallet_wrong_network: 'The wallet is on a different network. Switch it to TON mainnet.',
  },
  gas: {
    create: 'Creating a listing costs 0.3 GRAM. It is not a fee: the money sits on the deal contract as its reserve — for returning the NFT on cancellation and for payouts at closing. Whatever is left comes back to you when the deal closes.',
    lock: 'Locking the NFT costs 0.3 GRAM. Of that, 0.1 goes to the deal so it learns about the collateral; the rest is spent by the NFT contract itself.',
    pay: 'The payment carries 0.02 GRAM for processing: the contract subtracts exactly that, the rest counts against the debt. That is a network fee, not our commission.',
    refund: 'Leftover gas returns to the seller’s side on any outcome: closing, default or cancellation. 0.05 GRAM stays on the contract to pay for storage while the deal may still be needed.',
    simple: 'On top of the payment the contract takes a small processing surcharge — the app adds it for you. That is a network fee, not our commission: the commission is withheld from the payments themselves.',
    title: 'How much GRAM is added',
  },
  guide: {
    after_down_payment_they: 'Once you have paid the down payment it is out of their hands: the NFT is in the contract, and it goes back to them only if you stop paying. Then they get the item and you get part of what you paid — how much, they stated up front, before your first payment.',
    can_i_late_payment: 'Can I be late with a payment?',
    can_t_show_telegram: 'Nobody can dispose of it until the last payment: the owner is the contract, not the seller’s or the buyer’s wallet. That is exactly what protects both sides.',
    contract_does_transfer_automatically: 'The contract does the transfer itself, in the same transaction. No waiting for the seller, no messages, nothing to ask for.',
    faq: 'FAQ',
    gift_sits_contract_while: 'The NFT sits in the contract while you pay',
    gift_stays_contract_whole: 'The down payment goes first, the rest in weekly payments. All that time the NFT sits in the contract: the seller no longer has it, and it has not reached you yet.',
    how_works: 'How it works',
    last_payment_gift_yours: 'The last payment makes the NFT yours',
    moment_they_can_t: 'From that minute they cannot sell it, hand it to anyone else or take it back. The item waits for you in the contract, not in their wallet.',
    pay_parts: 'You pay in parts, on a schedule',
    premium_price_paying_over: 'The difference is what the instalments cost. The seller gives up the item now and gets the money over months; the premium is their reward for waiting. We show the market price right next to ours — compare it, and buy outright if that suits you better.',
    seller_puts_gift_into: 'The seller puts the NFT into the contract',
    what_if_seller_changes: 'What if the seller changes their mind?',
    why_price_above_floor: 'Why is the price above the market floor?',
    yes_grace_period_144: 'A little — yes. Every deal has a grace period: from two to eight days, and the smaller the refund on default, the longer it runs. While it lasts the deal is alive and the payment goes through as usual. And if the seller allowed deferrals, the whole schedule can shift by a week — for a separate fee.',
  },
  history: {
    cancelled: 'Deal cancelled',
    default_claimed: 'Payments defaulted',
    deferral: 'Payment deferred',
    nft_locked: 'NFT locked in the contract',
    owed_withdrawn: 'Money collected from the deal',
    payment: 'Payment',
    position_assigned: 'Position handed over',
    position_listed: 'Position listed for sale',
    position_sold: 'Position bought out',
  },
  incoming: {
    counter_terms: 'Counter with your terms',
    offered_total: 'OFFERED IN TOTAL',
    premium_words: 'That is {{premium}} over floor · {{count}} payments across {{days}} days',
  },
  inviter: {
    asks: 'ASKS',
    came_by_link: 'You came here from an invite',
    lead: 'You came through their link. Here are their listings and offers — a good place to start.',
    look: 'SEE IT',
    no_offers: 'No listings right now.',
    no_requests: 'No offers right now.',
    offers: 'Their listings',
    requests: 'Their offers',
    title: 'Your inviter\'s storefront',
    to_market: 'See the whole market',
    unknown: 'The link was not recognised — showing the general market.',
  },
  market: {
    all_collections: 'All',
    ask_here: 'Nothing fits? Name your own price',
    can_ask: 'People have',
    can_ask_hint: 'Nobody listed these for sale — they simply belong to people who use this app. Your offer goes to the owner personally, and they are free not to answer.',
    deferrals: 'Deferrals',
    down: 'DOWN',
    each_shifts_whole_schedule: 'Each shifts the whole schedule by a week',
    floor_here: 'buy outright on the market',
    floor_short: 'FLOOR',
    grace_period: 'Grace period',
    hard_coded_contract_never: 'Hard-coded in the contract, never above 5%',
    how_late_may_after: 'How late you may be after the payment date',
    more: 'More',
    no_holdings: 'Nothing here yet',
    no_holdings_hint: 'We show items belonging to people who use this app, and this collection has none yet. Name your price instead — every holder of the collection will see the offer.',
    no_offers: 'Nobody has listed an installment plan yet',
    no_offers_hint: 'No need to wait: name your price in an offer, and holders of the collection will see it.',
    nothing_found: 'Nothing found',
    offers: 'NFT',
    on_sale_now: 'FOR SALE',
    per_week: 'PER WEEK',
    pick_collection: 'Which collection?',
    ready_buy: 'Ready to buy',
    refund_short: 'REFUND',
    search_collection: 'Search by name',
    total_word: 'in total',
    want_installments: 'Ask for installments',
    weeks_short: 'wk',
  },
  mine: {
    all_on_sale: 'Your {{count}} eligible NFTs are listed for sale: while a lot sits on a marketplace, its contract owns it. Unlist them and they show up here.',
    already_listed: 'Already listed — one step left: hand the item to the contract',
    also_on_sale: '{{count}} more are listed for sale — unlist them first to use as collateral',
    incoming: 'Incoming',
    lead: 'Your NFTs from the collections accepted here. Pick one to list in installments — you set the terms.',
    list_it: 'List it',
    load_failed: 'Either TON API or our server did not answer — what you own and which collections are accepted come from them. It does not mean you have nothing to list: try again.',
    load_failed_title: 'The list did not load',
    my_nfts: 'My NFTs',
    nothing_hint: 'Your wallet holds no NFTs from the admitted collections. Meanwhile, here are the offers other people get — you can answer one once you have an item.',
    nothing_title: 'Nothing to list yet',
    outgoing: 'Outgoing',
    waiting_buyer: 'In the contract, waiting for a buyer',
  },
  nav: {
    admin: 'Admin',
    board: 'Offers',
    deals_buyer: 'Deals · buyer',
    deals_seller: 'Deals · seller',
    offer: 'Listing',
    positions_full: 'Contracts',
  },
  offer: {
    contract_not_wallet_here: 'In the contract, not in your wallet. Here\'s why — 30 seconds',
    get_back: 'YOU GET BACK',
    if_stop_paying: 'If you stop paying',
    lose: 'YOU LOSE',
    pay_today: 'PAY TODAY',
    payment_schedule: 'Payment schedule',
    point: 'AT THIS POINT',
    terms: 'Terms',
    upfront_never_back: 'The {{upfront}} down payment never comes back. The {{refund}}% refund counts only the payments made after it.',
    upfront_share: 'Down payment · {{pct}}% of the price · non-refundable',
    where_gift_sits_until: 'Where the NFT sits until the last payment',
  },
  positions: {
    buy: 'Buy it',
    buy_hint: 'The contract swaps the money for the right to the remaining payments in a single transaction. The NFT stays in escrow until the deal ends: if the buyer defaults, it becomes yours.',
    contact_seller: 'Handover terms are between you and the seller. The contract moves only the right to the payments.',
    discipline_late: 'Behind schedule',
    discipline_ok: 'Pays on time',
    empty: 'Nobody has listed a position yet',
    in_escrow: 'In escrow',
    in_escrow_label: 'IN ESCROW',
    left_to_receive: 'Left to receive',
    mine: 'Your position',
    owner: 'Position owner',
    payments_done: 'Payments made',
    price: 'Position price, {{cur}}',
    sort_risk: 'BY DISCIPLINE',
    sort_soon: 'NEXT PAYMENT',
    sort_yield: 'BY REMAINDER',
    subtitle_full: 'The right to the remaining payments of someone else’s deal. The contract does the swap: the money reaches the owner in the same transaction that hands you the position. If the buyer defaults, the escrowed NFT becomes yours.',
    title_full: 'Invest in someone else’s deal',
  },
  profile: {
    balance: 'BALANCE · GRAM',
    confirm_first: 'Confirm the wallet to configure notifications.',
    history: 'History',
    history_empty: 'No operations yet',
    language: 'Language',
    notifications: 'Notifications',
    notify_grace: 'End of the grace period',
    notify_grace_note: 'The one that matters most',
    notify_pay: 'Payment date',
    notify_pay_note: 'Three days and one day before the date',
    notify_req: 'Offers on my collections',
    notify_req_note: 'Who offers what',
    proof_cancelled: 'The wallet window was closed — nothing was signed.',
    proof_timeout: 'The wallet did not respond. Try again.',
    referral: 'Invitations',
    referral_note: 'Two percent of the price goes to whoever brought the buyer',
    show_holdings: 'Show my NFTs',
    show_holdings_note: 'So people can offer you an installment deal',
    subscribe: 'Turn on notifications',
    subscribed: 'Notifications are on',
    telegram_only: 'Notifications only work inside Telegram.',
    theme: 'Theme',
    theme_dark: 'Dark',
    theme_light: 'Light',
    wallet_did_not_sign: 'The wallet did not sign the confirmation',
    what_we_send: 'We write about payment dates, answers to your offers, and money about to burn.',
    why_proof: 'The signature proves the wallet is yours. Without it anyone could subscribe to your deals. Asked once.',
  },
  ref: {
    code: 'Code',
    copied: 'Copied',
    copy: 'Copy',
    deals: 'Their deals',
    disabled: 'Invitations are off for now.',
    failed: 'Could not get the link.',
    go_confirm: 'Confirm the wallet',
    how_1: 'Share your link. It opens the showcase, and the person sees right away that they came from you.',
    how_2: 'They buy on instalments — in any collection, not only yours. Their very first purchase counts.',
    how_3: 'With each of their payments your share splits off our fee and accrues on the deal. When the deal closes it goes to your wallet.',
    how_title: 'How it works',
    invited: 'Invited',
    invited_by: 'You came through an invitation. It will apply on your first purchase.',
    lead: '40% of our fee goes to whoever brought the buyer: with a 5% fee that is two percent of the price. Not on top of the price, but out of the same fee — the buyer pays no more.',
    link_opens: 'It opens the showcase, with a line above it telling the person they came from an invite and letting them look at what you offer. The invite pays off on their first purchase — in any collection, not only yours.',
    need_wallet: 'Connect and confirm a wallet — that is where the share will arrive.',
    not_confirmed: 'The wallet is not confirmed. Open the profile and confirm it with a signature — the link is bound to the wallet, and the share arrives there.',
    onchain_note: 'The contract pays, not us: the share splits off the fee at the very moment the fee is taken.',
    open_profile: 'Open the profile',
    paid: 'Paid out, {{cur}}',
    pending: 'Accrued, {{cur}}',
    pending_note: 'What is accrued leaves when the deal closes — in one sum, together with the fee.',
    self_note: 'Your own second wallet will not work. An invitation is issued to an account, not an address, and you cannot invite yourself.',
    share: 'Share',
    title: 'Invite and earn',
    visits: 'Visits',
    visits_note: 'How many different people opened the app through your link. Your own visits do not count.',
    your_link: 'Your link',
  },
  request: {
    answers: 'Answers',
    down_payment: 'DOWN PAYMENT',
    every: 'every',
    expired: 'Expired',
    goes_to_owner: 'to this item’s owner, personally',
    model: 'to every holder of the collection',
    my: 'My offers',
    new: 'New offer',
    none: 'No offers yet',
    request_goes: 'The offer goes',
    scope_collection: 'Collection offer',
    scope_collection_hint: 'Everyone holding such an item sees it. Any of them can answer — whoever agrees first is who you deal with.',
    scope_item: 'Item offer',
    scope_item_hint: 'Only this item’s owner sees it, and only they can answer. A refusal closes the offer.',
    send: 'Send the offer',
    sent: 'Offer sent',
    sent_hint: '{{count}} holders of this collection now know about it. The answer arrives here and in the bot.',
    sent_to_owner: 'The offer went to the owner personally — nobody else sees it. The answer arrives here and in the bot.',
    status_accepted: 'Terms accepted',
    status_cancelled: 'Withdrawn',
    status_countered: 'Answered',
    status_declined: 'Declined',
    status_open: 'Waiting for an answer',
    term_weekly_payments: 'TERM · WEEKLY PAYMENTS',
    tier_is_sellers: 'The refund level and deferrals are the seller’s call — they come with their answer.',
    what_seller_sees: 'WHAT THE SELLER SEES',
    willing_pay_total: 'WILLING TO PAY IN TOTAL, {{cur}}',
    withdraw: 'Withdraw the offer',
  },
  seller: {
    ask_price: 'Position price, {{cur}}',
    buyer_pays_until: 'Buyer pays by',
    claim_gift: 'Take the NFT back',
    claim_gift_hint: 'The grace period is over. The NFT comes back to you, the buyer gets the refund the terms promise.',
    list: 'List for sale',
    listed_for: 'Listed for',
    new_owner_address: 'New owner address',
    next_payment: 'Next payment',
    sell_position: 'Sell the position',
    sell_position_hint: 'The right to the remaining payments goes to whoever pays the price you name. The contract does the swap itself: the money reaches you in the same transaction that hands the position over. The NFT stays in escrow.',
    transfer_position: 'Hand over the position',
    transfer_position_hint: 'The right to the remaining payments moves to this address. The price is between the two of you — the contract holds no money for the position.',
    unlist: 'Remove from sale',
  },
  shell: {
    finish: 'Finish',
    nav_board: 'Mine',
    nav_builder: 'Listing',
    nav_deals: 'Deals',
    nav_market: 'Showcase',
    nav_profile: 'Profile',
    sub_admin: 'ADMIN',
    sub_board: 'YOUR NFTS, DEMAND AND HAGGLING',
    sub_builder: 'INSTALLMENT TERMS',
    sub_deals: 'YOUR COMMITMENTS',
    sub_guide: 'HOW IT WORKS',
    sub_inviter: 'listings and offers of whoever invited you',
    sub_market: 'NFTS IN INSTALLMENTS',
    sub_offer: 'LISTING',
    sub_profile: 'WALLET AND NOTIFICATIONS',
    sub_referral: 'a share of every deal your invitee makes',
    sub_request: 'INSTALLMENT OFFER',
    unfinished: 'Listed, but the NFT is not handed over — buyers do not see it',
  },
  state: {
    claim: 'Claim',
    close: 'Close',
    closed_hero: 'The NFT is yours',
    closed_note: 'Transferred to your wallet — it is entirely yours from now on.',
    connect_wallet: 'Connect a wallet — without one there are no deals and no offers to show.',
    failed_hero: 'The deal defaulted',
    failed_note: 'The grace period ended and the NFT went back to the seller.',
    forfeited: 'Kept by the seller',
    left: '{{x}} left',
    paid_total: 'Paid in total',
    refunded: 'Back to the buyer',
    retry: 'Try again',
    sent_waiting: 'Sent — waiting for the network',
    sent_waiting_hint: 'The network confirms a transfer in about a minute. The screen updates itself.',
    stuck_hero: 'The transfer did not arrive',
    stuck_note: 'The wallet rejected the payout and the money stayed in the contract. It is yours — claim it.',
    stuck_rare: 'A RARE ONE',
    waiting_upfront: 'Waiting for the down payment',
    waiting_upfront_hint: 'The NFT is already in the contract. The deal starts when the buyer pays the down payment.',
  },
  waiting: {
    lead: 'The seller handed over the NFT on the terms you accepted. The deal starts with your down payment — until then the seller can take the NFT back.',
    pay: 'Pay the down payment',
    section: 'Waiting for your down payment',
    title: 'The NFT is already in the contract',
  },
  wallet: {
    connect: 'Connect',
    copied: 'Copied',
    copy: 'Copy the address',
    disconnect: 'Disconnect the wallet',
    title: 'Wallet',
  },
};
